import * as Yup from 'yup';

import { FIELD_IS_REQUIRED } from 'src/common/validation/errors';
import type { IFilePayload } from 'src/types';

export const filePayloadValidationSchema = Yup.object<IFilePayload>()
  .shape(
    {
      fileName: Yup.string().required(FIELD_IS_REQUIRED),
      contentType: Yup.string().required(FIELD_IS_REQUIRED),

      content: Yup.string().when('uid', {
        is: (uid: string | undefined) => !uid,
        then: (schema) => schema.required(FIELD_IS_REQUIRED),
        otherwise: (schema) => schema.notRequired(),
      }),
      uid: Yup.string().when('content', {
        is: (content: string | undefined) => !content,
        then: (schema) => schema.required(FIELD_IS_REQUIRED),
        otherwise: (schema) => schema.notRequired(),
      }),
    },
    [['uid', 'content']]
  )
  .default(null);

export const filePayloadArrayValidationSchema = Yup.array<IFilePayload>()
  .of(
    Yup.object<IFilePayload>()
      .required()
      .shape(
        {
          fileName: Yup.string().required(FIELD_IS_REQUIRED),
          contentType: Yup.string().required(FIELD_IS_REQUIRED),

          content: Yup.string().when('uid', {
            is: (uid: string | undefined) => !uid,
            then: (schema) => schema.required(FIELD_IS_REQUIRED),
            otherwise: (schema) => schema.notRequired(),
          }),
          uid: Yup.string().when('content', {
            is: (content: string | undefined) => !content,
            then: (schema) => schema.required(FIELD_IS_REQUIRED),
            otherwise: (schema) => schema.notRequired(),
          }),
        },
        [['uid', 'content']]
      )
  )
  .min(1)
  .default([]);
